<template>
  <Flex
    v-if="!isProduction"
    gap="4px"
    align="center"
    class="dev-badge"
  >
    <Label
      style="
        background-color: #FF5757;
        height: 7px;
        width: 7px;
        border-radius: 50%;
      "
    />
    <Label text="dev" title="安心してください。dev環境です" />
  </Flex>
</template>

<script>
import Label from "../atoms/Label.vue";
import Flex from "../atoms/Flex.vue";


export default {
  name: 'DevBadge',
  components: {Flex, Label},
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production'
    },
  },
}
</script>

<style scoped>
.dev-badge {
  font-size: 12px;
  color: #aaa;
  padding: 2px 5px;
  border-radius: 4px;
  cursor: default;
  transition: 0.3s background-color;
}

.dev-badge:hover {
  background-color: #eee;
}
</style>
